<template>
  <div>
    <b-card class="mb-2 mc-general__label">
      <h5 class="mc-general__label">{{ $t('report.fields.dataSummary') }}</h5>
      <b-row>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="loadingGeofence_label"
            :label="$t('report.object.loadingGeofence')"
            label-for="loadingGeofence"
          >
            <span v-if="!dataSummary.isBusy">
              {{ loadingGeofenceLabel }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="dumpingGeofence_label"
            :label="$t('report.object.dumpingGeofence')"
            label-for="dumpingGeofence"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dumpingGeofenceLabel }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="periodReport_label"
            :label="$t('report.object.reportPeriod')"
            label-for="reportPeriod"
          >
            <span v-if="!dataSummary.isBusy">
              {{ periodeLabel }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="licensePlate_label"
            :label="$t('report.fields.licensePlate')"
            label-for="licensePlate"
          >
            <div v-if="!dataSummary.isBusy" class="d-flex align-items-center gap-2">
              <span>{{ licensePlateLabel }}</span>
              <McBadge
                v-if="vehicleIdCount > 2"
                :text="`+${vehicleIdCount - 2}`"
                variant="success"
                size="small"
                type="pill"
              />
            </div>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="totalRitage_label"
            :label="$t('report.object.totalRitage')"
            label-for="totalRitage"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.totalRitage ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageRitageDuration_label"
            :label="$t('report.object.averageRitageDuration')"
            label-for="averageRitageDuration"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.averageRitageDuration ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mb-2 mc-general__label">
      <h5 class="mc-general__label">{{ $t('report.fields.loadingCondition') }}</h5>
      <b-row>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageTravelDurationLoad_label"
            :label="$t('report.object.averageTravelDuration')"
            label-for="averageTravelDurationLoad"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.averageTravelDurationLoaded ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageStoppedDurationLoaded_label"
            :label="$t('report.object.averageStoppedDuration')"
            label-for="averageStoppedDurationLoaded"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.averageStoppedDurationLoaded ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageInGeofenceDurationLoad_label"
            :label="$t('report.object.averageInGeofenceDuration')"
            label-for="averageInGeofenceDurationLoad"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.averageDurationLoaded ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageSpeedLoad_label"
            :label="$t('report.object.averageSpeed')"
            label-for="averageSpeedLoad"
          >
            <span v-if="!dataSummary.isBusy">
              {{
                dataSummary.data
                  ? `${dataSummary.data.averageSpeedLoaded} ${$t('report.object.kmPerHour')}`
                  : '-'
              }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mb-2 mc-general__label">
      <h5 class="mc-general__label">{{ $t('report.fields.unloadingCondition') }}</h5>
      <b-row>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageTravelDurationUnload_label"
            :label="$t('report.object.averageTravelDuration')"
            label-for="averageTravelDurationUnload"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.averageTravelDurationUnloaded ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageStoppedDurationUnloaded_label"
            :label="$t('report.object.averageStoppedDuration')"
            label-for="averageStoppedDurationUnloaded"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.averageStoppedDurationUnloaded ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageInGeofenceDurationUnload_label"
            :label="$t('report.object.averageInGeofenceDuration')"
            label-for="averageInGeofenceDurationUnload"
          >
            <span v-if="!dataSummary.isBusy">
              {{ dataSummary.data?.averageDurationUnloaded ?? '-' }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
        <b-col class="pt-2" sm="12" md="3">
          <b-form-group
            id="averageSpeedUnload_label"
            :label="$t('report.object.averageSpeed')"
            label-for="averageSpeedUnload"
          >
            <span v-if="!dataSummary.isBusy">
              {{
                dataSummary.data
                  ? `${dataSummary.data.averageSpeedUnloaded} ${$t('report.object.kmPerHour')}`
                  : '-'
              }}
            </span>
            <b-skeleton width="70%" v-else />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import McBadge from '@/components/McBadge'
export default {
  data() {
    return {
      reportKey: 'summary-ritage-geofence',
      filterDetail: {},
    }
  },
  components: {
    McBadge,
  },
  mounted() {
    this.filterDetail = this.getReportDetail(this.reportKey) ?? {}
  },
  mixins: [Helper],
  computed: {
    filters() {
      return this.$store.state.report.filterReport
    },
    dataSummary() {
      return this.$store.state.report.summaryRitageReport.summary
    },
    periodeLabel() {
      return this.filters.periode
        ? this.momentDateShortMonth(this.filters.periode[0]) +
            ' - ' +
            this.momentDateShortMonth(this.filters.periode[1])
        : '-'
    },
    loadingGeofenceLabel() {
      if (this.filters.ritage) {
        return this.filterDetail != {} ? this.filterDetail.loadingFenceName : '-'
      } else {
        return '-'
      }
    },
    dumpingGeofenceLabel() {
      if (this.filters.ritage) {
        return this.filterDetail != {} ? this.filterDetail.dumpingFenceName : '-'
      } else {
        return '-'
      }
    },
    licensePlateLabel() {
      if (this.filters.vehicleId && this.filters.vehicleId.length > 0) {
        return this.filterDetail != {} ? this.filterDetail.licensePlate : '-'
      } else {
        return '-'
      }
    },
    vehicleIdCount() {
      return this.filters.vehicleId && this.filters.vehicleId.length > 0
        ? this.filters.vehicleId.length
        : 0
    },
    filterValue() {
      return this.$store.state.report.filterValue
    },
  },
}
</script>
